import { createGlobalStyle } from 'styled-components';

const BaseStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
    width: 100%;
    overflow-x:hidden;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
    font-family: 'JetBrains Mono';
  }
  *::selection{
    background-color: var(--color-primary);
    color:#fff;
  }
  *::-moz-selection{
    background-color: var(--color-primary);
    color:#fff;
  }

  body {
    margin: 0;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background: var(--color-background);
    color: var(--color-text);
    overflow-x:hidden;
    &::-webkit-scrollbar{
      display:none;
    }
  
  }

  body, h1, h2, h3, h4, h5, h6, hr, p, blockquote,dl, dt, dd, ul, ol, li,pre,fieldset,legend, button, input, textarea, th, td {
        margin: 0;
        padding: 0;
        color: var(--color-text);
    };
    ul, ol { 
        list-style: none; 
    }
    a {
        color: var(--color-text);
        text-decoration: none; 
        &:hover {
          color: var(--color-primary)
        }
    }
    input{
        -webkit-appearance: none;
        border: 0;
        outline: 0;
        background: transparent;
        color: inherit;
    }
    ::-webkit-input-placeholder {
        color: inherit;
        opacity: 0.4;
    }

    ::placeholder {
        color: inherit;
        opacity: 0.4;
    }
    textarea{ 
        -webkit-appearance: none;
        resize: none;
        border: 0;
        outline: 0;
        background: transparent;
        color: inherit;
    }
    ::-webkit-textarea-placeholder {
        color: inherit;
        opacity: 0.4;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
   textarea:-webkit-autofill:hover,  
   input:-webkit-autofill:hover, 
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--color-text);
    transition: background-color 5000s ease-in-out 0s;
}


input[type=range] {
  -webkit-appearance: none;
  width: 30%;
  height: 2px;
  border-radius: 2px;
  background: var(--color-text);
  outline: none;
  padding: 0;
  margin: 0;
  cursor:pointer;
  @media (max-width: 768px) {
    width: 50%;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width:25px;
    height:25px;
    background: var(--color-primary);
    border-radius: 50%;
    border:4px solid var(--color-background);
    transition: background .15s ease-in-out;
  }
  &::-moz-range-thumb {
    -webkit-appearance: none;
    width:16px;
    height:16px;
    border-radius: 50%;
    background: var(--color-primary);
    border:4px solid var(--color-background);
    transition: background .15s ease-in-out;
  }
}
 
  input[type=range]:focus {
    outline: none;
}

`;

export default BaseStyles;
